module.exports = __webpack_public_path__ + "img/81.3.TP.e97441e7.png";